import red from '@material-ui/core/colors/red';
import { emphasize } from '@material-ui/core/styles/colorManipulator';

export const FORM_WIDTH = '800px';
const errorRed = 'red';

export const generalClasses = theme => ({
  positionAbsolute: {
    position: 'absolute'
  },
  middleWidthContainer: {
    width: '50%',
    display: 'inline-flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    '& > div:nth-child(2)': {
      paddingTop: '0px',
      marginTop: '0px',
      '& > label': {
        paddingLeft: '43px',
        [theme.breakpoints.down('sm')]: {
          paddingLeft: '3px'
        }
      }
    }
  },
  flexSpaceAround: {
    display: 'flex',
    justifyContent: 'space-between',
    '& > div:nth-child(4)': {
      paddingLeft: '0px'
    },
    [theme.breakpoints.down('md')]: {
      '& > div:nth-child(4)': {
        width: '28%'
      }
    },
    [theme.breakpoints.down('sm')]: {
      '& > div:nth-child(4)': {
        width: '30%'
      }
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      '& > div': {
        width: '100%',
        margin: '0px 0px 0px 0px'
      },
      '& > div:nth-child(4)': {
        width: '100%',
        paddingLeft: '10px'
      }
    }
  },
  card: {
    alignSelf: 'center',
    width: FORM_WIDTH,
    overflow: 'inherit',
    margin: '15px 0px 15px 0px',
    '& > div:nth-child(2)': {
      paddingBottom: '0px'
    }
  },
  cardColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  cardContent: {
    padding: '0px'
  },
  cardTitle: {
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    padding: '0px 10px 0px 10px',
    '& div span': {
      color: 'white',
      fontSize: '1.2rem',
      padding: '13px 23px'
    }
  },
  titlePdl0: {
    '& div span': {
      paddingLeft: '0'
    }
  },
  thirdWidth: {
    width: '33%',
    padding: '0px 30px 0px 30px',
    margin: '15px 0px 15px 0px'
  },
  quarterWidth: {
    width: '25%',
    padding: '0px 30px 0px 30px',
    margin: '15px 0px 15px 0px',
    '& + .quarterWidth': {
      padding: '0px 10px 0px 10px'
    },
    '& > label': {
      padding: '0px 0px 0px 38px'
    }
  },

  checkBoxField: {
    '& > span:first-child': {
      height: '35px'
    },
    '& > span:nth-child(2)': {
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: '0.8em'
    },
    marginLeft: '0px'
  },
  middleWidth: {
    width: '50%',
    padding: '0px 30px 0px 30px',
    margin: '15px 0px 15px 0px',
    '& label': {
      padding: '0px 0px 0px 3px'
    },
    '& > label': {
      padding: '0px 0px 0px 38px'
    }
  },
  fullWidth: {
    width: '100%',
    padding: '0px 30px 0px 30px',
    margin: '25px 0px 25px 0px',
    '& label': {
      padding: '0px 0px 0px 3px'
    }
  },
  fingerContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '120px',
    marginTop: '17px',
    '& > div': {
      width: '65px',
      height: '65px',
      border: '1px solid #eaeaea',
      borderRadius: '50%'
    },
    '& > div > div': {
      marginTop: '25px',
      width: '40px',
      height: '40px',
      top: '5px',
      marginLeft: '12px',
      '& > svg': {
        overflow: 'initial',
        '& > circle': {
          r: '35',
          strokeWidth: '2',
          animation: 'none',
          strokeDasharray: 'none'
        }
      }
    },
    '& > svg': {
      height: '1.8em',
      width: '1.8em',
      top: '27px'
    },

    '& button': {
      bottom: '8px'
    },
    '& > div:last-child': {
      bottom: '-20px',
      fontSize: '12px',
      position: 'absolute'
    }
  },
  fingerErrorContainter: {
    '& > div > div': {
      '& > div': {
        color: '#ff0000'
      },
      backgroundColor: '#ff0606b0'
    },
    '& > div > svg > g > path': {
      color: 'white'
    }
  },
  fingerWarningContainer: {
    '& > div > div': {
      '& > div': {
        color: '#ff7a00'
      },
      backgroundColor: '#ffc395'
    },
    '& > div > svg > g > path': {
      color: 'white'
    }
  },
  fingerDisabledContainer: {
    '& > div > div': { backgroundColor: '#eaeaea57' },
    '& > div > div > div': {
      color: 'rgba(0, 0, 0, 0.26)'
    }
  },
  fingerOkContainer: {
    '& > div > div': {
      backgroundColor: '#2b9c34bf',
      '& > div': {
        color: '#62906b'
      }
    },
    '& > div > svg > g > path': {
      color: 'white'
    }
  },
  fingerRunningContainter: {
    '& > div > div > div > svg > circle': {
      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
      strokeDasharray: '80px, 200px'
    }
  },
  midSixWidth: {
    width: '15%',
    padding: '10px 10px 10px 10px'
  },
  fullWidthError: {
    width: '100%',
    padding: '0px 30px 0px 30px',
    margin: '-15px 0px 15px 0px',
    color: '#ff7a00',
    fontSize: '10px'
  },
  error: {
    '& label': {
      color: errorRed
    },
    '& div::before': {
      borderColor: errorRed
    }
  },
  dniControl: {
    display: 'inline-flex',
    flex: '1 0',
    flexDirection: 'row',
    alignItems: 'flex-end',
    '& > span': {
      padding: '0px 10px 0px 10px'
    },
    '& label > span': {
      paddingLeft: '2px'
    },
    '& > div:first-child': {
      width: 'calc(100% - 80px)'
    }
  },
  errorDniControl: {
    padding: '0px 30px 0px 30px',
    margin: '-15px 0px 15px 0px'
  },
  dni: {
    width: '50px',
    '& > input': {
      textAlign: 'center'
    }
  },
  errorMessages: {
    fontSize: '10px',
    color: errorRed
  },
  notMargin: {
    margin: '0'
  },
  marginBottom: {
    marginBottom: '25px'
  },
  flexEnd: {
    alignItems: 'flex-end'
  },

  emptyError: {
    color: 'transparent',
    fontSize: '5px',
    width: '5px',
    height: '12px'
  },
  [theme.breakpoints.down('sm')]: {
    middleWidth: {
      width: '100%',
      padding: '0px 15px 0px 15px',
      '& label': {
        padding: '0px 0px 0px 3px'
      },
      '& > label': {
        padding: '0px 0px 0px 19px'
      }
    },
    fullWidth: {
      padding: '0px 15px 0px 15px',
      '& label': {
        padding: '0px 0px 0px 18px'
      }
    },
    quarterWidth: {
      width: '100%',
      padding: '0px 15px 0px 15px',
      '& > label': {
        padding: '0px 0px 0px 19px'
      }
    },
    card: {
      width: '100%'
    }
  }
});

export const selectInput = theme => ({
  input: {
    display: 'flex',
    padding: 0
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden'
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08
    )
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
  },
  singleValue: {
    fontSize: 16
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0
  },
  divider: {
    height: theme.spacing.unit * 2
  },
  noNormalizedAddress: {
    '& > div > div > label, & > label, ': {
      color: '#ff7a00'
    },
    '& > div:before, & > div > div > div:before': {
      borderBottom: '2px solid #ff7a00'
    }
  }
});

export const add = theme => ({
  formSubscriptor: {
    display: 'flex',
    flexDirection: 'column'
  },
  collapseContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  card: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  media: {
    height: 0,
    paddingTop: '56.25%' // 16:9
  },
  actions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    padding: '20px 0px 20px 24px',
    alignSelf: 'center',
    width: FORM_WIDTH
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  avatar: {
    backgroundColor: red[500]
  },
  fingerTooltip: {
    bottom: '70%'
  },
  [theme.breakpoints.down('sm')]: {
    actions: {
      width: '100%'
    },
    collapseContainer: {
      '& > div': {
        width: '100%'
      }
    }
  },
  [theme.breakpoints.down('xs')]: {}
});

export const service = theme => ({
  ...selectInput(theme),
  ...generalClasses(theme),
  serviceSelect: {
    width: 'calc(100% - 100px)',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important'
    }
  },
  serviceSelectForm: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: '20px 0px 20px 0px',
    padding: '0px 30px 0px 30px',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flex: '1 0',
      padding: '0px 15px 0px 15px',
      flexWrap: 'wrap'
    }
  }
});

export const endorsement = theme => ({
  ...selectInput(theme),
  ...generalClasses(theme)
});

export const patient = theme => ({
  ...selectInput(theme),
  ...generalClasses(theme),
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0px 17px',
    '& > div': {
      margin: '0'
    },
    [theme.breakpoints.down('sm')]: {
      margin: '0px 0px'
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  }
});

export const subscriber = theme => ({
  ...selectInput(theme),
  ...generalClasses(theme)
});

export const subscriptorList = theme => ({
  card: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: '0'
    }
  },
  cardContent: {
    [theme.breakpoints.down('xs')]: {
      padding: '0'
    }
  }
});

export const resultsContainer = theme => {
  const styles = {
    ...selectInput(theme),
    ...generalClasses(theme),

    squareState: {
      width: '32%',
      height: '80px',
      color: 'white',
      padding: '10px',
      flexWrap: 'wrap',
      flexDirection: 'row',
      display: 'flex',
      backgroundColor: '#008016db',
      '& > div:nth-child(1)': {
        alignSelf: 'flex-start',
        width: '100%'
      },
      '& > div:nth-child(2)': {
        alignSelf: 'flex-end',
        width: 'calc(100% - 40px)',
        fontWeight: '700',
        fontSize: '20px'
      },
      '& > div:nth-child(3)': {
        alignSelf: 'flex-end',
        width: '40px',
        height: '40px',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        backgroundColor: '#ffffff42',
        '& > svg': {
          width: '75%',
          height: '75%'
        },
        '&:empty': {
          background: 'transparent'
        }
      },

      '& > div:nth-child(4)': {
        width: '100%',
        textAlign: 'end',
        position: 'relative',
        top: '-18px',
        [theme.breakpoints.down('sm')]: {
          fontSize: '12px'
        },
        [theme.breakpoints.down('xs')]: {
          top: '-5px'
        }
      },
      [theme.breakpoints.down('sm')]: {
        width: '33%',
        '& > div:nth-child(2)': {
          fontSize: '18px'
        }
      }
    },
    squareTextState: {
      color: 'gray',
      width: '32%',
      padding: '10px',
      fontSize: '13px',
      minHeight: '70px',
      justifyContent: 'flex-start',
      '& > div:nth-child(2)': {
        fontSize: '14px',
        padding: '10px 0px 3px 0px',
        fontWeight: '600'
      },
      '&.orangeBck': {
        border: '5px solid #ff841a'
      },
      [theme.breakpoints.down('xs')]: {
        '&:empty': {
          width: '0px',
          height: '0px',
          padding: '0px',
          margin: '0'
        }
      }
    },
    doubleSquare: {
      width: '68%',
      '& > div:nth-child(2)': {
        fontSize: '25px'
      },
      '&.no-decision > div:nth-child(2)': {
        width: 'auto'
      },
      '&.no-decision > div:nth-child(3)': {
        width: '0px'
      },
      '&.no-decision > div:nth-child(4)': {
        paddingBottom: '2px',
        width: 'auto',
        position: 'initial',
        textAlign: 'justify',
        alignSelf: 'flex-end',
        '& > span': {
          paddingLeft: '4px'
        }
      },
      [theme.breakpoints.down('xs')]: {
        '& > div:nth-child(2)': {
          fontSize: '20px'
        }
      }
    },
    mountResult: {
      '& > div:nth-child(2)': {
        fontSize: '17px'
      }
    },
    grayBck: {
      backgroundColor: '#b1b1b1 !important'
    },
    orangeBck: {
      backgroundColor: '#daa84c'
    },
    whiteBck: {
      backgroundColor: 'white',
      [theme.breakpoints.down('xs')]: {
        display: 'none'
      }
    }
  };

  styles.card.width = '1100px !important';
  styles['@media (max-width:1220px)'] = {
    card: {
      width: '100% !important'
    }
  };

  return styles;
};

export const reasons = theme => {
  const styles = {
    ...selectInput(theme),
    ...generalClasses(theme),
    cardContent: {
      padding: '10px'
    },
    flexHReasons: {
      color: 'gray',
      padding: '5px 0px',
      fontSize: '13px',

      display: 'flex',
      '& > div:nth-child(1)': {
        width: '30%'
      },
      '& > div:nth-child(2)': {
        width: '70%'
      },
      '&:not(:first-child)': {
        fontWeight: '700'
      },
      [theme.breakpoints.down('xs')]: {
        '&:first-child': {
          '& > div:nth-child(2)': { display: 'none' }
        },
        '& > div:nth-child(1)': {
          width: '100%'
        },
        '& > div:nth-child(2)': {
          width: '100%'
        },
        '&:not(:first-child)': {
          flexDirection: 'column'
        }
      }
    }
  };
  styles.card.width = '1100px';
  styles['@media (max-width:1220px)'] = {
    card: {
      width: '100%'
    }
  };
  return styles;
};
